import { createQueryHook } from '~/shared/providers/api';

export interface FacilityCounts {
  userCount: number;
  roleCount: number;
}

export interface FacilityCountsResult {
  counts: Record<string, FacilityCounts>;
}

export const useFacilityCountsQuery = createQueryHook(
  'settings.teamPermissions.facilityCounts',
  () => ({
    coreUserRoleAssignments: {
      __args: {
        filter: {
          pagination: {
            limit: 10000,
            offset: 0,
          },
        },
      },
      entries: {
        facilityId: true,
        userId: true,
        roleId: true,
      },
    },
  }),
  {
    select: (data): FacilityCountsResult => {
      const entries = data?.coreUserRoleAssignments?.entries ?? [];

      const facilityUserSets = new Map<string, Set<string>>();
      const facilityRoleSets = new Map<string, Set<string>>();

      entries.forEach((assignment) => {
        const { facilityId, userId, roleId } = assignment;
        if (!facilityId) return;

        if (!facilityUserSets.has(facilityId)) {
          facilityUserSets.set(facilityId, new Set());
          facilityRoleSets.set(facilityId, new Set());
        }

        if (userId) {
          facilityUserSets.get(facilityId)?.add(userId);
        }
        if (roleId) {
          facilityRoleSets.get(facilityId)?.add(roleId);
        }
      });

      const counts: Record<string, FacilityCounts> = {};
      facilityUserSets.forEach((users, facilityId) => {
        counts[facilityId] = {
          userCount: users.size,
          roleCount: facilityRoleSets.get(facilityId)?.size ?? 0,
        };
      });

      return { counts };
    },
  },
);
